export class EntitySearchCriteria {

  entityName!: string;
  searchTerm!: string;
  orgUnitId!: string;
  personId!: string;
  excludeParts!: boolean;
  region!: string;
  approvalStatusCode!: string;
  lastUpdate!: string;

}
